import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";

export const IngredientListInput = ({ label, values = [], onChange, testId, placeholder }) => {
  const [draft, setDraft] = useState("");
  const add = () => {
    const value = draft.trim();
    if (!value) return;
    if (values.some((item) => item.toLowerCase() === value.toLowerCase())) { setDraft(""); return; }
    if (values.length >= 10) { toast.error("Maximum 10 items allowed"); return; }
    onChange([...values, value]);
    setDraft("");
  };
  return (
    <div>
      <Label htmlFor={`${testId}-input`} className="mb-2 block">{label}</Label>
      <div className="flex gap-2">
        <Input id={`${testId}-input`} value={draft} maxLength={120} placeholder={placeholder}
          className="rounded-xl min-w-0" onChange={(e) => setDraft(e.target.value)} onBlur={add}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }} data-testid={`${testId}-input`} />
        <Button type="button" variant="outline" className="rounded-full shrink-0" onClick={add}
          aria-label={`Add ${label.toLowerCase()}`} data-testid={`${testId}-add`}><Plus className="w-4 h-4" /></Button>
      </div>
      <div className="flex flex-wrap gap-2 mt-3" data-testid={`${testId}-list`}>
        {values.map((item, index) => (
          <span key={item} className="inline-flex items-center gap-1 max-w-full rounded-full bg-emerald-50 px-3 py-1 text-sm" data-testid={`${testId}-item-${index}`}>
            <span className="break-words min-w-0">{item}</span>
            <button type="button" onClick={() => onChange(values.filter((_, i) => i !== index))} className="shrink-0 p-1 rounded-full hover:bg-emerald-100"
              aria-label={`Remove ${item}`} data-testid={`${testId}-remove-${index}`}><X className="w-3 h-3" /></button>
          </span>
        ))}
      </div>
    </div>
  );
};